export default "__VITE_ASSET__Dxeg_XQp__"